require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-when-it-comes-to-learning-design-and-code-two-local-6th-graders-say-do-it.json") })
        }
      }, "path---blog-when-it-comes-to-learning-design-and-code-two-local-6th-graders-say-do-it");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-when-it-comes-to-learning-design-and-code-two-local-6th-graders-say-do-it!./.cache/json/blog-when-it-comes-to-learning-design-and-code-two-local-6th-graders-say-do-it.json
// module id = 1161
// module chunks = 231608221292675